import {
  AppFolder24Regular,
  AppGeneric24Regular,
  AppsList24Regular,
  Archive24Regular,
  ArrowCircleRight24Filled,
  ArrowCircleRight24Regular,
  ArrowCounterclockwise24Regular,
  ArrowDownload24Regular,
  ArrowEnterUp24Regular,
  ArrowExpand24Regular,
  ArrowReset24Regular,
  ArrowSort24Regular,
  ArrowSortUp24Regular,
  ArrowUndo24Regular,
  ArrowUpload24Regular,
  ArrowUpRight24Regular,
  Book24Regular,
  Bookmark24Regular,
  BookmarkAdd24Regular,
  BookSearch24Regular,
  Briefcase24Regular,
  Building24Regular,
  BuildingHome24Regular,
  BuildingSkyscraper24Regular,
  CalendarAdd24Regular,
  CalendarEdit24Regular,
  CalendarPlay24Regular,
  CalendarSync24Regular,
  Camera24Regular,
  ChartMultiple24Regular,
  CheckboxChecked24Regular,
  CheckboxUnchecked24Regular,
  CheckmarkSquare24Regular,
  CircleSmall24Regular,
  ClipboardTask24Regular,
  ClipboardTaskListLtr24Regular,
  Clock24Regular,
  CloudArrowUp24Regular,
  ColumnEdit24Regular,
  ColumnTriple24Regular,
  Copy24Regular,
  Cursor24Regular,
  Database24Regular,
  DatabaseSearch24Regular,
  DataLine24Regular,
  Desktop24Regular,
  DismissCircle24Regular,
  DocumentAdd24Regular,
  DocumentArrowDown20Regular, // TODO Why is this missing in 24?
  DocumentPdf24Regular,
  DocumentTable24Regular,
  Earth24Regular,
  Edit24Filled,
  EditOff24Regular,
  EmojiSmileSlight24Regular,
  Eraser24Regular,
  Eye24Regular,
  EyeOff24Regular,
  Flag24Regular,
  Folder24Regular,
  Form24Regular,
  FullScreenMaximize24Regular,
  FullScreenMinimize24Regular,
  Glance24Regular,
  Grid24Regular,
  GroupList24Regular,
  HeadphonesSoundWave24Regular,
  HomePerson24Regular,
  Key24Regular,
  Layer24Regular,
  LayerDiagonalRegular,
  LocalLanguage24Regular,
  LocationArrowRight20Regular,
  Mail24Regular,
  MoreHorizontal24Regular,
  MoreVertical24Regular,
  MyLocation24Regular,
  Navigation24Regular,
  Open24Regular,
  Person24Regular,
  PersonAdd24Regular,
  PersonFeedback24Regular,
  PersonQuestionMark24Regular,
  Phone24Regular,
  Play24Regular,
  QuestionCircle24Regular,
  Ruler24Regular,
  Save24Regular,
  Search24Regular,
  Settings24Regular,
  SignOut24Regular,
  Snooze24Regular,
  SplitHintRegular,
  SquareHint24Regular,
  Table24Regular,
  Tag24Regular,
  TextBulletListSquare24Regular,
  TextT24Regular,
  Video24Regular,
  Wand24Regular,
} from "@fluentui/react-icons";

function ArrowNext24Regular() {
  // Fluent UI version is scaled differently than chevron, this improves that
  return (
    <svg width="24" height="24" viewBox="0 0 28 28" fill="currentColor">
      <path
        d="M18.25 3c.38 0 .7.28.74.65l.01.1v16.5a.75.75 0 0 1-1.5.1V3.75c0-.41.34-.75.75-.75Zm-13.03.22a.75.75 0 0 1 .98-.07l.08.07 8.25 8.25c.27.27.3.68.07.98l-.07.08-8.25 8.25a.75.75 0 0 1-1.13-.98l.07-.08L12.94 12 5.22 4.28a.75.75 0 0 1 0-1.06Z"
        fill="currentColor"
        transform="translate(2 2)"
      />
    </svg>
  );
}

function Polygon24Regular() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M 5,21 A 3,3 0 0 1 2,18 3,3 0 0 1 4.5761719,15.03125 L 4.8007812,12.998047 4.9335938,11.796875 A 3,3 0 0 1 3,9 3,3 0 0 1 6,6 3,3 0 0 1 8.5175781,7.371094 L 9.3554688,7.091797 12.015625,6.203125 A 3,3 0 0 1 12,6 3,3 0 0 1 15,3 3,3 0 0 1 18,6 3,3 0 0 1 16.863281,8.349609 L 18,10.904297 18.507812,12.044922 A 3,3 0 0 1 19,12 a 3,3 0 0 1 3,3 3,3 0 0 1 -3,3 3,3 0 0 1 -2.677734,-1.660156 L 15.130859,16.595703 7.9960938,18.125 A 3,3 0 0 1 5,21 Z M 5,19.5 A 1.5,1.5 0 0 0 6.5,18 1.5,1.5 0 0 0 5,16.5 1.5,1.5 0 0 0 3.5,18 1.5,1.5 0 0 0 5,19.5 Z m 2.6757812,-2.841797 7.1406248,-1.529297 1.19336,-0.255859 A 3,3 0 0 1 17.136719,12.65625 L 16.628906,11.513672 15.494141,8.957031 A 3,3 0 0 1 15,9 3,3 0 0 1 12.482422,7.628906 L 9.8300781,8.513672 8.984375,8.794922 A 3,3 0 0 1 9,9 3,3 0 0 1 6.4257812,11.96875 l -0.1328124,1.195312 -0.2265626,2.039063 a 3,3 0 0 1 1.609375,1.455078 z M 19,16.5 A 1.5,1.5 0 0 0 20.5,15 1.5,1.5 0 0 0 19,13.5 1.5,1.5 0 0 0 17.5,15 1.5,1.5 0 0 0 19,16.5 Z M 6,10.5 A 1.5,1.5 0 0 0 7.5,9 1.5,1.5 0 0 0 6,7.5 1.5,1.5 0 0 0 4.5,9 1.5,1.5 0 0 0 6,10.5 Z m 9,-3 A 1.5,1.5 0 0 0 16.5,6 1.5,1.5 0 0 0 15,4.5 1.5,1.5 0 0 0 13.5,6 1.5,1.5 0 0 0 15,7.5 Z" />
    </svg>
  );
}

function LineString24Regular() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M 11 4 A 3 3 0 0 0 8 7 A 3 3 0 0 0 10.896484 9.9921875 L 11.193359 11.330078 L 11.638672 13.333984 A 3 3 0 0 0 10.027344 15.615234 L 9.1855469 15.720703 L 7.7890625 15.896484 A 3 3 0 0 0 5 14 A 3 3 0 0 0 2 17 A 3 3 0 0 0 5 20 A 3 3 0 0 0 7.9726562 17.384766 L 9.3710938 17.208984 L 10.21875 17.103516 A 3 3 0 0 0 13 19 A 3 3 0 0 0 16 16 A 3 3 0 0 0 13.101562 13.001953 L 12.658203 11.005859 L 12.359375 9.6660156 A 3 3 0 0 0 13.419922 8.7617188 L 14.763672 9.265625 L 16.019531 9.7363281 A 3 3 0 0 0 16 10 A 3 3 0 0 0 19 13 A 3 3 0 0 0 22 10 A 3 3 0 0 0 19 7 A 3 3 0 0 0 16.582031 8.2382812 L 15.326172 7.7675781 L 13.980469 7.2636719 A 3 3 0 0 0 14 7 A 3 3 0 0 0 11 4 z M 11 5.5 A 1.5 1.5 0 0 1 12.5 7 A 1.5 1.5 0 0 1 11 8.5 A 1.5 1.5 0 0 1 9.5 7 A 1.5 1.5 0 0 1 11 5.5 z M 19 8.5 A 1.5 1.5 0 0 1 20.5 10 A 1.5 1.5 0 0 1 19 11.5 A 1.5 1.5 0 0 1 17.5 10 A 1.5 1.5 0 0 1 19 8.5 z M 13 14.5 A 1.5 1.5 0 0 1 14.5 16 A 1.5 1.5 0 0 1 13 17.5 A 1.5 1.5 0 0 1 11.5 16 A 1.5 1.5 0 0 1 13 14.5 z M 5 15.5 A 1.5 1.5 0 0 1 6.5 17 A 1.5 1.5 0 0 1 5 18.5 A 1.5 1.5 0 0 1 3.5 17 A 1.5 1.5 0 0 1 5 15.5 z " />
    </svg>
  );
}

function MultiPoint24Regular() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M 10 4 A 3 3 0 0 0 7 7 A 3 3 0 0 0 10 10 A 3 3 0 0 0 13 7 A 3 3 0 0 0 10 4 z M 10 5.5 A 1.5 1.5 0 0 1 11.5 7 A 1.5 1.5 0 0 1 10 8.5 A 1.5 1.5 0 0 1 8.5 7 A 1.5 1.5 0 0 1 10 5.5 z M 18 11 A 3 3 0 0 0 15 14 A 3 3 0 0 0 18 17 A 3 3 0 0 0 21 14 A 3 3 0 0 0 18 11 z M 18 12.5 A 1.5 1.5 0 0 1 19.5 14 A 1.5 1.5 0 0 1 18 15.5 A 1.5 1.5 0 0 1 16.5 14 A 1.5 1.5 0 0 1 18 12.5 z M 6 14 A 3 3 0 0 0 3 17 A 3 3 0 0 0 6 20 A 3 3 0 0 0 9 17 A 3 3 0 0 0 6 14 z M 6 15.5 A 1.5 1.5 0 0 1 7.5 17 A 1.5 1.5 0 0 1 6 18.5 A 1.5 1.5 0 0 1 4.5 17 A 1.5 1.5 0 0 1 6 15.5 z " />
    </svg>
  );
}

function Filter24Regular() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="m 4.2324219,3.0019531 c -0.5179022,0 -0.8930531,-0.038977 -1.3320313,0.1992188 -0.3181597,0.172656 -0.5682432,0.44291 -0.7226562,0.765625 C 1.9669669,4.4073343 2.0019531,4.7765763 2.0019531,5.328125 v 0.6601562 c 0,0.2647198 -0.00762,0.454686 0.052734,0.6992188 0.046381,0.1879876 0.1234816,0.3676436 0.2285156,0.53125 0.1371206,0.2135877 0.2828609,0.3363889 0.4707032,0.5097656 L 8.6679688,13.1875 h 0.00195 c 0.1877334,0.173225 0.2286803,0.224 0.2265625,0.220703 0.014264,0.02258 0.025914,0.05056 0.033203,0.08008 4.224e-4,0.0017 0.00781,0.07512 0.00781,0.339844 v 6.488281 c 0,0.389794 -0.072736,0.679439 0.1914063,1.103516 0.168981,0.271672 0.4424654,0.475358 0.765625,0.546875 0.5117767,0.113427 0.7616927,-0.08569 1.1015627,-0.230469 l 3.144531,-1.337891 c 0.167849,-0.07156 0.342625,-0.126422 0.541016,-0.318359 0.140777,-0.136197 0.245163,-0.303476 0.308593,-0.484375 0.08861,-0.253338 0.07227,-0.426606 0.07227,-0.619141 v -5.148437 c 0,-0.26321 0.0073,-0.337126 0.0078,-0.339844 v -0.002 c 0.0074,-0.02898 0.0194,-0.05613 0.0332,-0.07813 l 0.002,-0.002 c -0.0015,0.0026 0.04044,-0.04699 0.226562,-0.21875 L 21.246094,7.7285156 C 21.433865,7.5551795 21.579612,7.4325075 21.716797,7.21875 21.821687,7.0552606 21.89887,6.875108 21.945312,6.6875 22.00548,6.4431924 21.998047,6.253001 21.998047,5.9882812 V 5.328125 c 0,-0.5515487 0.03501,-0.9207826 -0.175781,-1.3613281 C 21.667912,3.6442732 21.417909,3.3738659 21.099609,3.2011719 20.660646,2.9629698 20.285525,3.0019531 19.767578,3.0019531 Z m 0,1.5 H 19.767578 c 0.517947,0 0.660552,0.04111 0.617188,0.017578 0.02977,0.016154 0.06292,0.045666 0.08594,0.09375 -0.0092,-0.01922 0.02734,0.1632951 0.02734,0.7148438 v 0.6601562 c 0,0.2647198 -0.0093,0.3380052 -0.0098,0.3398438 -0.0076,0.030529 -0.01864,0.057378 -0.0332,0.080078 0.0023,-0.00365 -0.0387,0.045331 -0.226562,0.21875 l -5.914063,5.4589849 c -0.187882,0.173385 -0.33557,0.298245 -0.472656,0.511718 -0.104839,0.163478 -0.182089,0.341861 -0.228516,0.529297 v 0.002 c -0.06017,0.24431 -0.05078,0.434497 -0.05078,0.699219 v 5.148437 c 0,0.0602 0.0053,0.01076 0.0039,0.03906 -0.01824,0.0085 0.01287,-0.0094 -0.01367,0.002 l -3.11914,1.328125 c -0.0011,-0.03167 0.0039,0.0076 0.0039,-0.0293 v -6.488281 c 0,-0.264722 0.0096,-0.454717 -0.05078,-0.699219 v -0.002 c -0.0464,-0.1879 -0.123654,-0.365835 -0.228516,-0.529297 -0.13701,-0.21326 -0.2847031,-0.33829 -0.4726561,-0.511718 L 3.7714844,6.6269531 C 3.5836402,6.4535746 3.5426839,6.4047172 3.5449219,6.4082031 3.5304234,6.3856195 3.5191574,6.3582746 3.5117188,6.328125 3.5113205,6.3265116 3.5019531,6.253001 3.5019531,5.9882812 V 5.328125 c 0,-0.5515487 0.036535,-0.7340558 0.027344,-0.7148438 0.022916,-0.047893 0.056097,-0.077557 0.085937,-0.09375 -0.043355,0.023525 0.099285,-0.017578 0.6171875,-0.017578 z" />
    </svg>
  );
}

function LocationFilled() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.16 16.88l-1.19 1.18-3.4 3.3c-.88.85-2.26.85-3.13 0l-3.5-3.39-1.1-1.09a8.7 8.7 0 1112.32 0z" />
    </svg>
  );
}

function GoToLocation24Regular() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C12.3797 2 12.6935 2.28215 12.7432 2.64823L12.75 2.75L12.7491 4.53771C16.2928 4.88757 19.1124 7.70719 19.4632 11.2525L19.5 11.25H21.25C21.6642 11.25 22 11.5858 22 12C22 12.3797 21.7178 12.6935 21.3518 12.7432L21.25 12.75L19.4617 12.749C19.1124 16.2928 16.2928 19.1124 12.7475 19.4632L12.75 19.5V21.25C12.75 21.6642 12.4142 22 12 22C11.6203 22 11.3065 21.7178 11.2568 21.3518L11.25 21.25L11.251 19.4617C7.70719 19.1124 4.88757 16.2928 4.53678 12.7475L4.5 12.75H2.75C2.33579 12.75 2 12.4142 2 12C2 11.6203 2.28215 11.3065 2.64823 11.2568L2.75 11.25L4.53771 11.2509C4.88757 7.70719 7.70719 4.88757 11.2525 4.53678L11.25 4.5V2.75C11.25 2.33579 11.5858 2 12 2ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6Z"
        fill="currentColor"
      />
    </svg>
  );
}

function Legend24Regular() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect
        x="3.75"
        y="3.75244"
        width="5.76427"
        height="5.76427"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="6.85303"
        y="14.3544"
        width="3.9482"
        height="3.9482"
        transform="rotate(45 6.85303 14.3544)"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0578 5.72344V3H15.2417L15.2417 5.72344H12.5156V7.5395H15.2417L15.2417 10.2643H17.0578V7.5395H19.7799V5.72344H17.0578Z"
        fill="currentColor"
      />
      <rect
        x="13.7109"
        y="14.4844"
        width="5.76427"
        height="5.76427"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}

function MapOff() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 9.25 3.9980469 L 9.203125 4 L 9.1386719 4.0078125 L 9.015625 4.0351562 C 8.9472652 4.0577362 8.8804162 4.0917288 8.8164062 4.1367188 L 6.6425781 5.6660156 L 7.7988281 6.6855469 L 8.4980469 6.1933594 L 8.4980469 7.3027344 L 10 8.6289062 L 10 6.1933594 L 14 9.0058594 L 14 12.15625 L 15.5 13.480469 L 15.5 9.0078125 L 19.5 6.1972656 L 19.5 14.996094 L 18.228516 15.888672 L 19.386719 16.908203 L 20.681641 15.998047 L 20.761719 15.933594 C 20.912419 15.792794 21 15.594064 21 15.384766 L 21 4.7519531 L 20.994141 4.6484375 C 20.921141 4.1060985 20.286059 3.8098825 19.818359 4.1386719 L 14.751953 7.7011719 L 9.6816406 4.1367188 L 9.6289062 4.1015625 C 9.5480064 4.0536425 9.4643162 4.0234856 9.3789062 4.0097656 L 9.3632812 4.0058594 C 9.3408114 4.0024594 9.3173519 4.00129 9.2949219 4 L 9.25 3.9980469 z M 4.0117188 4.1855469 A 0.75 0.75 0 0 0 3.4960938 4.4375 A 0.75 0.75 0 0 0 3.5625 5.4960938 L 5.0351562 6.7949219 L 3.3164062 8.0019531 L 3.2363281 8.0683594 C 3.0855585 8.209129 2.9980469 8.4059148 2.9980469 8.6152344 L 2.9980469 19.248047 L 3.0058594 19.353516 C 3.0787992 19.895914 3.7119685 20.190128 4.1796875 19.861328 L 9.25 16.296875 L 14.353516 19.888672 C 14.593514 20.037472 14.914741 20.052834 15.181641 19.865234 L 17.777344 18.039062 L 19.4375 19.503906 A 0.75 0.75 0 0 0 20.496094 19.4375 A 0.75 0.75 0 0 0 20.429688 18.378906 L 4.5546875 4.3710938 A 0.75 0.75 0 0 0 4.0117188 4.1855469 z M 6.1914062 7.8164062 L 8.4980469 9.8515625 L 8.4980469 14.992188 L 4.4980469 17.804688 L 4.4980469 9.0058594 L 6.1914062 7.8164062 z M 10 11.175781 L 14 14.705078 L 14 17.804688 L 10 14.992188 L 10 11.175781 z M 15.5 16.029297 L 16.621094 17.019531 L 15.5 17.806641 L 15.5 16.029297 z "
        fill="currentColor"
      />
    </svg>
  );
}

export const icons = {
  appFolder: <AppFolder24Regular />,
  appGeneric: <AppGeneric24Regular />,
  appsList: <AppsList24Regular />,
  archive: <Archive24Regular />,
  arrowCircle: <ArrowCircleRight24Regular />,
  arrowCircleFilled: <ArrowCircleRight24Filled />,
  arrowCounterclockwise: <ArrowCounterclockwise24Regular />,
  arrowDownload: <ArrowDownload24Regular />,
  arrowEnterUp: <ArrowEnterUp24Regular />,
  arrowExpand: <ArrowExpand24Regular />,
  arrowNext: <ArrowNext24Regular />,
  arrowReset: <ArrowReset24Regular />,
  arrowUpload: <ArrowUpload24Regular />,
  arrowUpRight: <ArrowUpRight24Regular />,
  arrowUndo: <ArrowUndo24Regular />,
  arrowSort: <ArrowSort24Regular />,
  arrowSortUp: <ArrowSortUp24Regular />,
  book: <Book24Regular />,
  bookmark: <Bookmark24Regular />,
  bookmarkAdd: <BookmarkAdd24Regular />,
  bookSearch: <BookSearch24Regular />,
  briefcase: <Briefcase24Regular />,
  building: <Building24Regular />,
  buildingHome: <BuildingHome24Regular />,
  buildingSkyscraper: <BuildingSkyscraper24Regular />,
  calendarAdd: <CalendarAdd24Regular />,
  calendarEdit: <CalendarEdit24Regular />,
  calendarPlay: <CalendarPlay24Regular />,
  calendarSync: <CalendarSync24Regular />,
  camera: <Camera24Regular />,
  chartMultiple: <ChartMultiple24Regular />,
  checkboxUnchecked: <CheckboxUnchecked24Regular />,
  checkboxChecked: <CheckboxChecked24Regular />,
  checkmarkSquare: <CheckmarkSquare24Regular />,
  circleSmall: <CircleSmall24Regular />,
  columnEdit: <ColumnEdit24Regular />,
  columnTriple: <ColumnTriple24Regular />,
  copy: <Copy24Regular />,
  clipboardTask: <ClipboardTask24Regular />,
  clipboardTaskList: <ClipboardTaskListLtr24Regular />,
  clock: <Clock24Regular />,
  cloudArrowUp: <CloudArrowUp24Regular />,
  cursor: <Cursor24Regular />,
  database: <Database24Regular />,
  databaseSearch: <DatabaseSearch24Regular />,
  dataLine: <DataLine24Regular />,
  desktop: <Desktop24Regular />,
  dismissCircle: <DismissCircle24Regular />,
  documentAdd: <DocumentAdd24Regular />,
  documentArrowDown: <DocumentArrowDown20Regular />,
  documentPdf: <DocumentPdf24Regular />,
  documentTable: <DocumentTable24Regular />,
  earth: <Earth24Regular />,
  editFilled: <Edit24Filled />,
  editOff: <EditOff24Regular />,
  emojiSmileSlight: <EmojiSmileSlight24Regular />,
  eraser: <Eraser24Regular />,
  eye: <Eye24Regular />,
  eyeOff: <EyeOff24Regular />,
  filter: <Filter24Regular />,
  flag: <Flag24Regular />,
  folder: <Folder24Regular />,
  form: <Form24Regular />,
  fullScreenMaximize: <FullScreenMaximize24Regular />,
  fullScreenMinimize: <FullScreenMinimize24Regular />,
  geomLineString: <LineString24Regular />,
  geomMultiLineString: <LineString24Regular />,
  geomMultiPoint: <MultiPoint24Regular />,
  geomMultiPolygon: <Polygon24Regular />,
  geomPoint: <CircleSmall24Regular />,
  geomPolygon: <Polygon24Regular />,
  glance: <Glance24Regular />,
  goToLocation: <GoToLocation24Regular />,
  grid: <Grid24Regular />,
  groupList: <GroupList24Regular />,
  headphones: <HeadphonesSoundWave24Regular />,
  help: <QuestionCircle24Regular />,
  homePerson: <HomePerson24Regular />,
  key: <Key24Regular />,
  layer: <Layer24Regular />,
  layerDiagonal: <LayerDiagonalRegular />,
  legend: <Legend24Regular />,
  localLanguage: <LocalLanguage24Regular />,
  locationArrow: <LocationArrowRight20Regular />,
  locationFilled: <LocationFilled />,
  mail: <Mail24Regular />,
  mapOff: <MapOff />,
  moreHorizontal: <MoreHorizontal24Regular />,
  moreVertical: <MoreVertical24Regular />,
  myLocation: <MyLocation24Regular />,
  navigation: <Navigation24Regular />,
  open: <Open24Regular />,
  person: <Person24Regular />,
  personAdd: <PersonAdd24Regular />,
  personFeedback: <PersonFeedback24Regular />,
  personQuestionMark: <PersonQuestionMark24Regular />,
  phone: <Phone24Regular />,
  play: <Play24Regular />,
  ruler: <Ruler24Regular />,
  save: <Save24Regular />,
  search: <Search24Regular />,
  settings: <Settings24Regular />,
  signOut: <SignOut24Regular />,
  snooze: <Snooze24Regular />,
  splitHint: <SplitHintRegular />,
  squareHint: <SquareHint24Regular />,
  table: <Table24Regular />,
  tag: <Tag24Regular />,
  textBulletListSquare: <TextBulletListSquare24Regular />,
  textT: <TextT24Regular />,
  video: <Video24Regular />,
  wand: <Wand24Regular />,
};
